import React, { Fragment, Component } from 'react';
import { contains } from 'ramda';
import PropTypes from 'prop-types';
import cn from 'classnames';
import ReactTooltip from 'react-tooltip';

import styles from './styles.m.scss';

import magic from '../../util/magic';

const afcLanguage = {
  education: 'Meet the educational requirement through one of the approved pathways.',
  examination: 'Pass the AFC® exam.',
  experience: 'Submit 1000 hours of financial counseling experience and the Employment Verification Form.',
  ethics: 'Sign and adhere to the Sage Financial Solutions® Code of Ethics.',
  review: 'Audit your submitted information and issue your certification upon completion!',
};
const ffcLanguage = {
  education: 'Meet the financial knowledge prerequisite.',
  examination: 'Complete the coaching competency checkpoints and pass the recorded coaching session evaluation.',
  experience: 'Submit hours of financial coaching experience.',
  ethics: 'Sign and adhere to the Sage Financial Solutions® Code of Ethics.',
  review: 'Audit your submitted information and issue your certification upon completion!',
};
const afccLanguage = {
  education: 'Meet the educational requirement.',
  examination: 'Pass the Personal Finance and Financial Counseling & Debt Management exams.',
  experience: 'Submit 2 years of financial counseling experience and and the Employment Verification Form.',
  ethics: 'Sign and adhere to the Sage Financial Solutions® Code of Ethics.',
  review: 'Audit your submitted information and issue your certification upon completion!',
};

class StatusBoxes extends Component {
  static propTypes = {
    certificationId: PropTypes.number,
    step: PropTypes.string,
  };

  renderTooltip = (id, header, body) => (
    <ReactTooltip
      id={id}
      place="top"
      type="light"
      effect="solid"
      className={styles.tooltip}
      getContent={() => (
        <Fragment>
          <div className="yellow-heading mt-2">{header}</div>
          <hr className="my-2" />
          <p>{body}</p>
        </Fragment>
      )}
    />
  );

  getBoxClassName = (boxStep, registrationIndex) => {
    const { step } = this.props;

    if (contains(magic.moduleStepPrefix, step)) {
      registrationIndex = magic.postRegistrationSteps.indexOf(magic.examStep);
    }

    const boxIndex = magic.postRegistrationSteps.indexOf(boxStep);

    if (registrationIndex < boxIndex) return styles.unfinished;
    else if (registrationIndex > boxIndex) return styles.finished;
    else return styles.inProgress;
  };

  render() {
    const { certificationId, step } = this.props;
    const registrationIndex = magic.postRegistrationSteps.indexOf(step);
    let language = afcLanguage;

    // TODO: make this less hardcoded
    if (certificationId == 7) {
      language = ffcLanguage;
    } else if (certificationId == 4) {
      language = afccLanguage;
    }

    return (
      <div className="d-flex align-items-center mb-4">
        <div
          data-tip=""
          data-for={`education-${certificationId}`}
          className={cn(styles.box, 'font-weight-bold', this.getBoxClassName(magic.educationStep, registrationIndex))}
        >
          Education
        </div>
        <span className={styles.spacer} />
        <div
          data-tip=""
          data-for={`examination-${certificationId}`}
          className={cn(styles.box, 'font-weight-bold', this.getBoxClassName(magic.examStep, registrationIndex))}
        >
          Examination
        </div>
        <span className={styles.spacer} />
        <div
          data-tip=""
          data-for={`experience-${certificationId}`}
          className={cn(styles.box, 'font-weight-bold', this.getBoxClassName(magic.experienceStep, registrationIndex))}
        >
          Experience
        </div>
        <span className={styles.spacer} />
        <div
          data-tip=""
          data-for={`ethics-${certificationId}`}
          className={cn(styles.box, 'font-weight-bold', this.getBoxClassName(magic.ethicsStep, registrationIndex))}
        >
          Ethics
        </div>
        <span className={styles.spacer} />
        <div
          data-tip=""
          data-for={`review-${certificationId}`}
          className={cn(styles.box, 'font-weight-bold', this.getBoxClassName(magic.reviewStep, registrationIndex))}
        >
          Review
        </div>

        {this.renderTooltip(`education-${certificationId}`, 'To Complete EDUCATION, you must', language.education)}
        {this.renderTooltip(
          `examination-${certificationId}`,
          'To Complete EXAMINATION, you must',
          language.examination,
        )}
        {this.renderTooltip(`experience-${certificationId}`, 'To Complete EXPERIENCE, you must', language.experience)}
        {this.renderTooltip(`ethics-${certificationId}`, 'To Complete ETHICS, You Must', language.ethics)}
        {this.renderTooltip(`review-${certificationId}`, 'To Complete REVIEW, Sage Financial Solutions will', language.review)}
      </div>
    );
  }
}

export default StatusBoxes;
